//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Array,
            default: ()=> {
                return []
            }
        }
    },
    computed: {
        weekItemFull() {
            return this.value.length === 5
        },
        totalWeekNum() {
            let total = 0;
            this.value.forEach(item => {
                total += item.num;
            })
            return total
        }
    },
    methods: {
        showWeekLable(index) {
            this.$vux.alert.show({
                title: this.value[index].label,
                content: this.value[index].desc
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/WeeksChart.vue